import React from 'react';

const PartnerContext = React.createContext({});

export default PartnerContext;
